import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Button, ButtonVariant, LoadingScreen, ErrorScreen } from "@withfriendsco/wf-components";
import OnlineStoreInstructions from './OnlineStore';
import InstoreInstructions from './Instore';
const INTEGRATE_QUERY = gql `
  query IntegrateQuery($id: ID!) {
    business(id: $id) {
      id
      alias
      name
      oneLiner
      status
      defaultRebate
      website
      logo {
        url
        cdnPath
      }
      theme {
        highlightColor
        darkColor
        defaultColor
        font
      }
      abbreviatedBenefits(isSuper: true)
      currencyCode
      membershipTiers {
        name
        manualDiscountCode
        discounts {
          scope
          percentage
          disclaimer
        }
        welcomeGift {
          name
        } 
        subscriptionBenefit {
          name
          delivery
          deliveryFrequency
          shippingFrequency {
            number
            period
          }
        }
        plans {
          kind
          price {
            amount
          }
        }
      }
      platforms {
        name
        mode
        connected
      }
      features {
        name
        completed
      }
    }
  }
`;
const IntegrateScreen = ({ businessId }) => {
    const { data, loading, error } = useQuery(INTEGRATE_QUERY, {
        variables: { id: businessId }
    });
    if (loading)
        return _jsx(LoadingScreen, {});
    if (error)
        return _jsx(ErrorScreen, { message: error.message });
    if (!data)
        return _jsx(ErrorScreen, {});
    const business = data.business;
    const platforms = business.platforms;
    const clickOnboarding = () => {
        const els = document.getElementsByClassName('wf-magic-moment-onboarding-trigger');
        if (els && els.length > 0) {
            const el = els[0];
            if (el instanceof HTMLElement) {
                el.click();
            }
        }
    };
    const instorePlatforms = platforms.filter(p => p.mode === 'IN_STORE');
    const onlinePlatforms = platforms.filter(p => p.mode === 'ONLINE');
    const hasDiscounts = business.membershipTiers.some(tier => (tier.discounts.length && tier.discounts.some(d => d.percentage)));
    const hasInstore = !!instorePlatforms.length;
    const hasOnline = !!onlinePlatforms.length;
    return (_jsxs("div", { children: [_jsx("h3", { children: "Integrate with your platforms" }), _jsx("p", { className: "mb-2 pt-4 text-wfGray-800 prose prose-xl max-w-none", children: "Get started with your new membership program by adding it to your online store, website, and physical receipts. When we detect that one of your customers has followed the link, we'll check off the item for you." }), business.status !== 'Live' && (_jsxs("div", { className: "border-2 border-salmon-600 p-4 font-bold", children: [_jsx("p", { className: "prose prose-xl text-wfGray-800 max-w-none", children: "Alert! Before adding these integrations, we highly advise completing your membership tiers and launching your memberships. Otherwise, your customers may receive upsells for memberships before you're ready." }), _jsx(Button, { className: "my-4", variant: ButtonVariant.Salmon, onClick: clickOnboarding, children: "Reopen membership setup screen to launch" })] })), hasInstore && _jsx(InstoreInstructions, Object.assign({}, business, { platforms: instorePlatforms, hasDiscounts: hasDiscounts })), hasOnline && _jsx(OnlineStoreInstructions, Object.assign({}, business, { platforms: onlinePlatforms, hasDiscounts: hasDiscounts })), _jsx("p", { className: "mb-2 pt-4 text-wfGray-800 prose prose-xl max-w-none", children: "If you'd like help, book a 15-minute setup session with us here:" }), _jsx(Button, { className: "my-4", variant: ButtonVariant.Outlined, onClick: () => { window.open("https://cal.com/kunalwithfriends/20min", '_blank', 'noopener=yes'); }, children: "Schedule a session" })] }));
};
export default IntegrateScreen;
export { INTEGRATE_QUERY }; // Add this at the bottom
